import {
  BET_STATUS_ALL,
  BET_STATUS_TO_SELL,
  BET_STATUS_SETTLED,
  getThreeMonthRange,
  rangeName,
  SET_BETS,
  SET_BETS_BY_REQUEST_TIME,
  SET_ORDER_CASHOUT_BETS,
  UPDATE_STATE,
  SET_BET,
  compositeBetStatuses
} from './constants'
import { chain, filter, find } from 'lodash'

const isBetStatusMatchesSelectedStatus = ({ betStatus, selectedBetStatus }) => {
  if (selectedBetStatus === BET_STATUS_ALL) {
    return compositeBetStatuses[BET_STATUS_ALL].includes(betStatus)
  } else if (selectedBetStatus === BET_STATUS_TO_SELL) {
    return compositeBetStatuses[BET_STATUS_TO_SELL].includes(betStatus)
  } else if (selectedBetStatus === BET_STATUS_SETTLED) {
    return compositeBetStatuses[BET_STATUS_SETTLED].includes(betStatus)
  } else {
    return selectedBetStatus === betStatus
  }
}

const isSameBet = bet1 => bet2 => bet1.betId === bet2.betId

const getSortedBets = (bets, selectedBetStatus, orderCashoutBets) => {
  let newBets
  if (selectedBetStatus === BET_STATUS_TO_SELL) {
    //  special case. we fetch all unsettled bets and then filter OUT all bets WITHOUT cashout
    newBets = filter(bets, ({ estimatedCashOut }) => estimatedCashOut)
  } else {
    newBets = bets
  }

  const betsWithOrderCashout = chain(newBets)
    .filter(
      ({ betId }) =>
        !!find(
          orderCashoutBets,
          ({ betId: betIdOrderCashout }) => betIdOrderCashout === betId
        )
    )
    .map((bet) => {
      const orderCashoutInfo = find(
        orderCashoutBets,
        ({ betId }) => betId === bet.betId
      )
      return {
        ...bet,
        orderCashoutInfo
      }
    })
    .value()

  const betsWithoutOrderCashout = filter(
    newBets,
    ({ betId }) => !find(orderCashoutBets, ['betId', betId])
  )

  return [...betsWithOrderCashout, ...betsWithoutOrderCashout]
}

export const getInitialState = ({ defaultRange, betStatus, itemsPerPage }) => ({
  selectedBetStatus: betStatus || BET_STATUS_ALL,
  activeTimeFilter: rangeName,
  range: defaultRange || getThreeMonthRange(),
  bets: [],
  orderCashoutBets: [],
  currentPage: 0,
  totalPages: 1,
  itemsPerPage: itemsPerPage || 10,
  isLoading: false,
  isError: false,
  lastRequestTime: null
})

export const betHistoryReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_STATE: {
      return {
        ...state,
        ...action.payload
      }
    }
    case SET_ORDER_CASHOUT_BETS: {
      const { bets, selectedBetStatus } = state
      const { orderCashoutBets } = action.payload

      return {
        ...state,
        ...action.payload,
        bets: getSortedBets(bets, selectedBetStatus, orderCashoutBets)
      }
    }
    case SET_BETS_BY_REQUEST_TIME: {
      if (action.payload.lastRequestTime === state.lastRequestTime) {
        const { orderCashoutBets, selectedBetStatus } = state
        const bets = action.payload.bets

        return {
          ...state,
          ...action.payload,
          bets: getSortedBets(bets, selectedBetStatus, orderCashoutBets)
        }
      }
      return state
    }
    case SET_BETS: {
      const { orderCashoutBets, selectedBetStatus } = state
      const bets = action.payload.bets

      return {
        ...state,
        ...action.payload,
        bets: getSortedBets(bets, selectedBetStatus, orderCashoutBets)
      }
    }
    case SET_BET: {
      const { bets, orderCashoutBets, selectedBetStatus } = state
      const updatedBet = action.payload

      const isUpdated = isSameBet(updatedBet)

      const stateHasThisBet = bets.some(isUpdated)

      const isBetStatusRelevant = isBetStatusMatchesSelectedStatus({ betStatus: updatedBet.betStatus, selectedBetStatus })
      // console.log('SET_BET : ', { bets, selectedBetStatus, stateHasThisBet, isBetStatusRelevant })

      if (stateHasThisBet) {
        // console.log('SET_BET : replacing existing bet', { bets, updatedBet })
        return {
          ...state,
          bets: bets.reduce((acc, bet) => {
            return acc.concat(isUpdated(bet) ? updatedBet : bet)
          }, [])
        }
      } else if (isBetStatusRelevant) {
        // add new bet (e.g. some unsettled bet became settled -> display it on the "settled" screen)
        // console.log('SET_BET : adding new bet', { bets, updatedBet })
        return {
          ...state,
          bets: getSortedBets(bets.concat(updatedBet), selectedBetStatus, orderCashoutBets)
        }
      } else {
        return state
      }
    }
    default:
      return state
  }
}
